import { DoorDefSchema, type EntityDef } from '@md/shared';
import {
  createEntity,
  defaultEntityId,
  ENTITY_PHASE_ACTUATOR,
  type EntityInstance,
} from './entity.js';

/**
 * Porte générique reliée à un interrupteur (concept §3.2).
 *
 * Solide tant que son signal est inactif ; `inverted: true` renverse la règle
 * (porte ouverte au repos, qui se referme quand le signal passe).
 */
export function createDoor(def: EntityDef): EntityInstance {
  const cfg = DoorDefSchema.parse(def);
  return createEntity({
    id: cfg.id ?? defaultEntityId('door', cfg.x, cfg.y),
    type: 'door',
    x: cfg.x,
    y: cfg.y,
    w: cfg.width,
    h: cfg.height,
    solid: true,
    phase: ENTITY_PHASE_ACTUATOR,
    flags: { open: 0, active: 0 },
    appearance: { shape: 'bar', tint: 0xc2703a, activeTint: 0x3a5a4a },
    update(self, ctx) {
      const signal = ctx.signal(cfg.linkedTo);
      const open = cfg.inverted ? !signal : signal;
      self.solid = !open;
      self.flags.open = open ? 1 : 0;
      self.flags.active = open ? 1 : 0;
    },
  });
}
